import React from "react";
import './account.css';
import Header from "../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../redux/rootReducer";
import { setUserSettingsSagaAction } from "../../redux/sagaActions";

const Account = () => {
    const dispatch = useDispatch();

    const user = useSelector(state => state.user);

    return (
        <>
            <Header/>
            <div className="page">
                <div className="settings">
                    <div className="setting">
                        <div className="setting__caption">Имя</div>
                        <input type="text" className="input" value={ user.name }
                            onInput={ event => dispatch(setUser({ ...user, name: event.target.value })) }
                            onBlur={ () => dispatch(setUserSettingsSagaAction({ field: 'name', value: user.name })) }
                        />
                    </div>
                    <div className="setting">
                        <div className="setting__caption">Блокировка уведомлений</div>
                        <div className="checkbox__row">
                            <div className="checkbox__wrapper"
                                 onClick={ () => {
                                     let newValue = '0';
                                     if (user.settings?.new_user === '0' || user.settings?.new_user === undefined) {
                                         newValue = '1';
                                     }
                                     else if (user.settings?.new_user === '1') {
                                         newValue = '0';
                                     }

                                     dispatch(setUser({ ...user, settings: { ...user.settings, new_user: newValue } }));
                                     dispatch(setUserSettingsSagaAction({
                                         field: 'settings',
                                         value: JSON.stringify({ ...user.settings, new_user: newValue })
                                     }));
                                 } }
                            >
                                <div className={ `checkbox ${ user.settings?.new_user === '1' ? 'checkbox--active' : '' } `}/>
                                <div className="checkbox__caption">Новые посетители</div>
                            </div>
                        </div>

                        <div className="checkbox__row">
                            <div className="checkbox__wrapper"
                                 onClick={ () => {
                                     let newValue = '0';
                                     if (user.settings?.new_booking === '0' || user.settings?.new_booking === undefined) {
                                         newValue = '1';
                                     }
                                     else if (user.settings?.new_booking === '1') {
                                         newValue = '0';
                                     }

                                     dispatch(setUser({ ...user, settings: { ...user.settings, new_booking: newValue } }));
                                     dispatch(setUserSettingsSagaAction({
                                         field: 'settings',
                                         value: JSON.stringify({ ...user.settings, new_booking: newValue })
                                     }));
                                 } }
                            >
                                <div className={ `checkbox ${ user.settings?.new_booking === '1' ? 'checkbox--active' : '' } `}/>
                                <div className="checkbox__caption">Записи на групповые занятия</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Account;